import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62f1410f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "impersonate-panel",
  class: "ImpersonatePanel"
}
const _hoisted_2 = { class: "ImpersonatePanel__content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Внимание! Вы авторизованы под сессией пользователя!", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Пожалуйста, "),
  /*#__PURE__*/_createElementVNode("u", null, "будьте внимательны")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("p", null, [
          (_ctx.impersonate_state.time > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" Сессия истечёт через " + _toDisplayString(_ctx.impersonate_state.time) + " " + _toDisplayString(_ctx.declOfNum(_ctx.impersonate_state.time, ['минуту', 'минуты', 'минут'])), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(" Сессия истекла ")
              ], 64))
        ])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_the_button, {
          class: "primary small",
          onClick: _ctx.impersonateQuit
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Выйти ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}